import React from 'react';
import PropTypes from 'prop-types';

import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEIcon from '../../../elements/oe-icon';
import OEButton from '../../../elements/controls/oe-button';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OEStdCapBarBare extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            middleStyle: null
        };

        this.onResizeLeft = this.onResizeLeft.bind(this);
        this.onResizeRight = this.onResizeRight.bind(this);

        this.onMainMenuControlBtnPressed = this.onMainMenuControlBtnPressed.bind(this);
        this.onFullscreenBtnPressed = this.onFullscreenBtnPressed.bind(this);
    }

    updateMiddleStyle() {
        let widthLeft = this.sizeLeft ? this.sizeLeft.w : 0;
        let widthRight = this.sizeRight ? this.sizeRight.w : 0;
        this.setState({
            middleStyle: {
                marginLeft: widthLeft.toString() + 'px',
                marginRight: widthRight.toString() + 'px'
            }
        });
    }

    onResizeLeft(sender, size)  {
        if(OEToolbox.shallowEqual(this.sizeLeft, size)) return;
        this.sizeLeft = size;
        this.updateMiddleStyle();
        if(this.props.onLeftResize) this.props.onLeftResize(sender, size);
    }

    onResizeRight(sender, size)  {
        if(OEToolbox.shallowEqual(this.sizeRight, size)) return;
        this.sizeRight = size;
        this.updateMiddleStyle();
        if(this.props.onRightResize) this.props.onRightResize(sender, size);
    }

    render() {
        const fullscreenBtn = !this.props.showFullscreenBtn ? null :
            <OEButton className="btn light-hover-bg-border" onPressed={this.onFullscreenBtnPressed}>
                <OEIcon code={this.props.isFullscreen ? OEIconCodes.compress : OEIconCodes.expand} />
            </OEButton>;

        return (
            <div className={'std-label-text-color std-cap-bar ' + this.props.className}>
                <div className="left">
                    <OEResizeObserver key="std-cap-bar-left" onResize={this.onResizeLeft}/>

                    <OEButton className="btn light-hover-bg-border" onPressed={this.onMainMenuControlBtnPressed}>
                        <OEIcon code={OEIconCodes.mainMenu} />
                    </OEButton>
                    <div className="light-bg-border spacer-flex-v"/>
                </div>

                <div
                    className="middle"
                    style={this.state.middleStyle}
                    ref={this.props.middleElementRef}
                >
                    {this.props.onMiddleResize ? <OEResizeObserver key="std-cap-bar-middle" onResize={this.props.onMiddleResize}/> : null}
                    {this.props.children}
                </div>

                <div className="right">
                    <OEResizeObserver key="std-cap-bar-right" onResize={this.onResizeRight}/>

                    {fullscreenBtn}
                    {fullscreenBtn ? <div className="light-bg-border spacer-flex-v"/> : null}
                </div>
            </div>
        );
    }

    onMainMenuControlBtnPressed()   {
        if(this.props.onMainMenuControlBtnPressed)   {
            this.props.onMainMenuControlBtnPressed();
            return;
        }
        if(!this.props.appComponent)    return;
        this.props.appComponent.uiLayer.onMainMenuControlBtnPressed();
    }

    onFullscreenBtnPressed()    {
        if(this.props.onFullscreenBtnPressed)   {
            this.props.onFullscreenBtnPressed();
            return;
        }
        if(this.props.appComponent && this.props.appComponent.appStateController)    this.props.appComponent.appStateController.setFullscreen(!this.props.isFullscreen);
    }
}

OEStdCapBarBare.defaultProps = {
    className: '',
    showFullscreenBtn: true,
    isFullscreen: false
};

OEStdCapBarBare.propTypes = {
    className: PropTypes.string,
    appComponent: PropTypes.object,
    showFullscreenBtn: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    onMainMenuControlBtnPressed: PropTypes.func,
    onFullscreenBtnPressed: PropTypes.func,
    middleElementRef: PropTypes.func,
    onLeftResize: PropTypes.func,
    onMiddleResize: PropTypes.func,
    onRightResize: PropTypes.func,
};